import { getBFFApiClient } from '@acp/feature/auth';
import {
    APIResponse, EstimatedQuotePrices, GetQuotesOptions, Quote,
} from '@acp/shared';
import HttpStatusCodes from 'http-status-codes';

async function getQuotes(options: GetQuotesOptions = {}) {
    const response = await getBFFApiClient().get<APIResponse<Quote[]>>('/v1/quote', {
        params: { ...options },
    });

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to get quotes: ${response.data.error}`);
    }

    return response.data.data;
}

async function getQuoteById(quoteId: number) {
    const response = await getBFFApiClient().get<APIResponse<Quote & { estimatedPrices: EstimatedQuotePrices }>>(`/v1/quote/${quoteId}`);

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to get quote for id: ${quoteId} due to ${response.data.error}`);
    }

    return response.data.data;
}

async function getImmediateActionQuotes({
    propertyManagerId = undefined,
}: {
    propertyManagerId?: string;
}) {
    const response = await getBFFApiClient().get<APIResponse<{
        total: number;
        items: Quote[];
    }>>(
        '/v1/quote/analytics/immediate-action',
        {
            params: {
                propertyManagerId,
            },
        }
    );

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to get quotes: ${response.data.error}`);
    }

    return response.data.data;
}

async function forwardQuote(
    id: number,
    toAddresses: string[],
    ccAddresses: string[],
    message: string | null,
    subscribeToNotifications: boolean
) {
    const response = await getBFFApiClient().post<APIResponse<null>>(`/v1/quote/${id}/forward`, {
        toAddresses,
        ccAddresses,
        message,
        subscribeToNotifications,
    });

    if (!response.data.success) {
        throw new Error(response.data.error);
    }

    if (response.status !== HttpStatusCodes.OK) {
        throw new Error('Failed to forward quote');
    }

    return response.data.data;
}

export {
    getQuotes,
    getQuoteById,
    getImmediateActionQuotes,
    forwardQuote,
};
